export const LOGIN_SUCCESS = '@auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = '@auth/LOGIN_FAILURE';
export const GET_PROFILE = '@auth/GET_PROFILE';
export const LOGOUT = '@auth/LOGOUT';